const reviews = [
  {
    name: 'Margaret D.',
    role: 'Property Manager, Morristown NJ',
    rating: 5,
    text: 'We manage a 24-unit apartment complex in Morristown and have been using TurnCraft for all of our unit turns for the past year and a half. Before finding them, we were constantly juggling multiple vendors — a painter here, a cleaner there — and units were sitting vacant longer than they should. TurnCraft consolidated everything under one roof. They show up when they say they will, the work is clean and consistent across every unit, and our maintenance supervisor doesn\'t have to babysit them. Highly recommend to any property manager in Morris County.',
  },
  {
    name: 'James T.',
    role: 'Commercial Real Estate Owner, Parsippany NJ',
    rating: 5,
    text: 'We brought TurnCraft in to repaint two floors of office space in our Parsippany building before a major new tenant moved in. The scope was large — roughly 8,000 square feet of walls, trim, and ceilings — and we needed it done over a single weekend to avoid disrupting the other tenants still in the building. They delivered completely. Every wall looked perfect, the drop cloths protected the floors perfectly, and the crew was out by Sunday afternoon as promised. The new tenant moved in Monday and was thrilled with the condition of the space. That\'s exactly what we needed from a contractor.',
  },
  {
    name: 'Linda R.',
    role: 'Residential Landlord, Chatham NJ',
    rating: 5,
    text: 'I own four rental units and have been a landlord for going on twelve years. I\'ve dealt with every kind of contractor you can imagine. What I appreciate most about TurnCraft is the communication. They confirm the day before, they update me during the job, and they call after to make sure I\'m happy. The cleaning crew left my two-bedroom apartment spotless — I\'m talking baseboards, inside the oven, behind the refrigerator, everything. The painter did a perfect job on the walls and ceilings with no drips, no missed spots. Priced fairly too. I won\'t use anyone else.',
  },
  {
    name: 'Robert A.',
    role: 'Facilities Director, Summit NJ',
    rating: 5,
    text: 'Our company\'s headquarters in Summit needed a full interior refresh — conference rooms, private offices, open work areas, and restrooms. I was managing multiple contractors for the project and TurnCraft was by far the easiest to work with. Their estimator was thorough and their quote was detailed. During the work, their crew was professional, worked cleanly around our equipment, and finished ahead of schedule. The quality of the paint application itself was excellent — smooth, even coverage, clean edges at every trim line. We\'ve already brought them back for a second location.',
  },
  {
    name: 'Susan M.',
    role: 'Leasing Manager, East Hanover NJ',
    rating: 5,
    text: 'TurnCraft helped us turn around a large 2-bedroom unit after a long-term tenant left it in rough shape. There was scuffing and marks on nearly every wall, the kitchen was in poor condition, and the bathrooms needed a thorough deep clean. Their team assessed everything upfront, gave us a clear scope and price, and completed the full turn in two days. The unit came out beautifully — fresh paint throughout, spotless kitchen and bathrooms, and everything smelling clean and neutral. We re-rented it within the first week of listing. That result speaks for itself.',
  },
  {
    name: 'David K.',
    role: 'Independent Landlord, Madison NJ',
    rating: 5,
    text: 'I was hesitant to trust a company I found online with my rental property, but TurnCraft came highly recommended by a colleague in the property management space. From the first call, they were professional and easy to deal with. They walked through the apartment with me, explained exactly what they would do and why, and stayed within the budget we discussed. The end result was a unit that looked better than when I originally purchased it. I\'ve since referred them to two other landlords in the Madison area, and both have had the same great experience.',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-chat-quote-line text-orange-500"></i>
            <span className="text-xs uppercase tracking-wider text-orange-500 font-semibold">
              Client Reviews
            </span>
          </div>
          <h2
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Trusted by Property Owners &amp; Managers
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            From individual landlords managing a single rental to commercial property directors overseeing multiple buildings, here is what our clients have to say about working with TurnCraft Property Solutions.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <article
              key={review.name}
              className="bg-white rounded-3xl p-8 flex flex-col"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-400 text-sm"></i>
                ))}
              </div>

              {/* Review text */}
              <blockquote className="text-sm text-gray-600 leading-relaxed flex-1 mb-6">
                &ldquo;{review.text}&rdquo;
              </blockquote>

              {/* Reviewer */}
              <footer className="border-t border-gray-100 pt-5">
                <p className="font-semibold text-gray-900 text-sm">{review.name}</p>
                <p className="text-xs text-gray-500 mt-0.5">{review.role}</p>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
